import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class AddKundorderradLagerplatserCommand extends BasicCommand<AddKundorderradLagerplatserCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<AddKundorderradLagerplatserCommand>;
    kundorderradId: number;
    lagerplatser: number[];

    constructor(kundorderradId: number) {
        super("AddKundorderradLagerplatserCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
